import React from 'react';

import {
  AttributeSearchSpaceTraceContext,
  type AttributeSearchSpaceTraceContextValue,
} from '@neptune/shared/attributes-domain';

export function useAttributeSearchSpaceTrace(): AttributeSearchSpaceTraceContextValue {
  return React.useContext(AttributeSearchSpaceTraceContext);
}
